import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import { LoadingSpinner } from "./spinners";
import IndexView from "./IndexView";
import SummaryView from "./SummaryView";
import RegistrationView from "./RegistrationView";
import CanvassingView from "./CanvassingView";
import ActiontMapView from "./ActiontMapView";
import MicroTargetingView from "./MicroTargetingView";
import ActivityAttendanceView from "./ActivityAttendanceView";
// import CrunchWeekView from "./CrunchWeekView";
import CrunchWeekCanvassingView from "./CrunchWeekCanvassingView";
// import CrunchLeaderView from "./CrunchLeaderView";
import CrunchCanvassingLeaderView from "./CrunchLeaderCanvassingView";
import IssueView from "./IssueView";
import UrlEnabled from "./UrlEnabled";

const AppRoutes = (): JSX.Element => (
  <Suspense fallback={<LoadingSpinner />}>
    <Routes>
      <Route path="/" element={<IndexView />} />
      <Route
        path="/:type/:code"
        element={<UrlEnabled enabledId="summary" page={<SummaryView />} />}
      />
      <Route
        path="/:type/:code/registration"
        element={
          <UrlEnabled enabledId="registration" page={<RegistrationView />} />
        }
      />
      <Route
        path="/:type/:code/canvassing"
        element={
          <UrlEnabled enabledId="canvassing" page={<CanvassingView />} />
        }
      />
      <Route
        path="/:type/:code/action"
        element={<UrlEnabled enabledId="action" page={<ActiontMapView />} />}
      />
      <Route
        path="/:type/:code/microtargeting"
        element={
          <UrlEnabled
            enabledId="microtargeting"
            page={<MicroTargetingView />}
          />
        }
      />

      <Route
        path="/:type/:code/issues"
        element={<UrlEnabled enabledId="issues" page={<IssueView />} />}
      />
      <Route
        path="/:type/:code/participation"
        element={
          <UrlEnabled
            enabledId="participation"
            page={<ActivityAttendanceView />}
          />
        }
      />
      <Route
        path="/:type/:code/crunchweek"
        element={
          <UrlEnabled enabledId="crunchweekcanvassing" page={<CrunchWeekCanvassingView />} />
        }
      />
      <Route
        path="/:type/:code/crunchweek-leader"
        element={
          <UrlEnabled enabledId="crunchweekcanvassinglead" page={<CrunchCanvassingLeaderView />} />
        }
      />
    </Routes>
  </Suspense>
);

export default AppRoutes;
